import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex font-montserrat flex-col justify-center items-center" }
const _hoisted_2 = {
  key: 0,
  class: "bg-green-600 border border-green-600 my-[10px] text-white text-center font-bold top-[80px] absolute z-30 rounded-[5px] max-w-[450px] w-[90%] p-[20px]"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-face-sad-tear" }, null, -1)
const _hoisted_4 = {
  key: 1,
  class: "bg-red-600 border border-red-600 my-[10px] text-white text-center font-bold top-[80px] absolute z-30 rounded-[5px] max-w-[450px] w-[90%] p-[20px]"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-face-sad-tear" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  id: "top",
  class: "lg:h-[80px] h-[50px]"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", { class: "w-full text-center font-bold mb-[20px]" }, "IronSecur / Désabonnement Newsletter", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Voulez-vous vraiment vous désabonner de notre newsletter ?", -1)

import HeaderComponent from '../components/HeaderComponent.vue'
  import { ref, onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  import FooterComponent from '@/components/FooterComponent.vue';
  import axiosInstance from '@/plugins/axios';
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Desabonnement',
  setup(__props) {

  const router = useRouter();
  function goToContactPage() {
      router.push('/contacts')
  }
  
  const pageTitle = ref('Désabonnement à la newsletter'); 
  
  onMounted(() => {
      document.title = pageTitle.value; 
  });
  
const Successmessage = ref('');
const Errormessage = ref('');
const unsubscribe = async () => {
  try {
    const { id, email } = router.currentRoute.value.params;
    const response = await axiosInstance.delete(`/subscribers/${id}/?email=${email}`);
    if (response.status === 200 || response.status === 201 || response.status === 204) {
      Successmessage.value = `Vous avez été désabonné avec succès de la newsletter.`;
      router.push('/');
    } else {
      Errormessage.value = `Une erreur s'est produite lors de la tentative de désabonnement.`;
    }
  } catch (error) {
    console.error('Erreur lors du désabonnement :', error);
    Errormessage.value = `Une erreur s'est produite lors de la tentative de désabonnement.`;
  }
};
  
  
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderComponent),
    (Successmessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(Successmessage.value) + " ", 1),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (Errormessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(Errormessage.value) + " ", 1),
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", { class: "relative" }, [
      _hoisted_6,
      _createElementVNode("div", { class: "container min-h-[500px] w-full relative flex justify-center items-center px-[10px]" }, [
        _createElementVNode("div", { class: "border p-[20px] bg-blue-100" }, [
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("button", {
            onClick: unsubscribe,
            class: "w-full text-center bg-cyan-500 text-white font-bold p-[10px] mt-[20px]"
          }, "Se désabonner")
        ])
      ])
    ]),
    _createVNode(FooterComponent)
  ]))
}
}

})